import React from 'react'
import PropTypes from 'prop-types'
import {Dialog, Button} from '@chakra-ui/react3'
import {CancelIcon} from '../icons'

import {useIntl} from 'react-intl'
import {hasValidString} from '../../utils/utils'
import useScrollLock from '../../../hooks/use-scroll-lock'
import RichText from '../cms/rich-text'

/**
 * Displays overlay.
 * Intended for use in leap modules.
 *
 * @component
 * @param {Object} children - Component children.
 * @returns {JSX.Element} Rendered overlay element.
 */

const OverlayComponent = ({children = {}, isOpen, onClose, background, title}) => {
    const {formatMessage} = useIntl()

    const hasTitle = hasValidString(title)

    useScrollLock(isOpen)

    return (
        <Dialog.Root
            placement="center"
            size="xl"
            scrollBehavior="inside"
            background={background}
            open={isOpen}
            onOpenChange={({open}) => {
                if (!open) onClose?.()
            }}
        >
            <Dialog.Backdrop>
                <Dialog.Positioner>
                    <Dialog.Content>
                        <Dialog.CloseTrigger asChild>
                            <Button
                                variant="secondaryGhost"
                                size={{base: 'sm', s: 'md'}}
                                aria-label={formatMessage({
                                    id: 'global.close',
                                    defaultMessage: 'Close'
                                })}
                            >
                                <CancelIcon />
                            </Button>
                        </Dialog.CloseTrigger>
                        {hasTitle && (
                            <Dialog.Header>
                                <Dialog.Title asChild>
                                    <RichText as="h2">{title}</RichText>
                                </Dialog.Title>
                            </Dialog.Header>
                        )}
                        <Dialog.Body>{children}</Dialog.Body>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Dialog.Backdrop>
        </Dialog.Root>
    )
}

OverlayComponent.propTypes = {
    children: PropTypes.node,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    background: PropTypes.string,
    title: PropTypes.string
}

export default OverlayComponent
